<template>
  <van-popup v-model:show="visible" position="bottom" round safe-area-inset-bottom teleport="body" @closed="handleClosed">
    <div class="edit-dialog">
      <div class="header">
        <div @click="handleCancel">取消</div>
        <div style="text-align: center; flex: 1; white-space: normal; overflow: hidden; text-overflow: ellipsis">{{ title }}</div>
        <div @click="confirm">{{ confirmTitle }}</div>
      </div>
      <div style="max-height: 70vh; overflow: auto">
        <slot></slot>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
    };
  },
  props: {
    confirmTitle: { type: String, default: "保存" },
    title: String,
  },
  mounted() {
    this.visible = true;
  },
  watch: {
    $route() {
      this.clear();
    },
  },
  emits: ["closed", "confirm", "cancel"],
  methods: {
    clear() {
      this.$editDialog.clear();
    },
    close() {
      this.visible = false;
    },
    handleClosed() {
      //执行删除
      this.$emit("closed", this);
      this.$editDialog.close();
    },
    confirm() {
      this.$emit("confirm", this.close);
    },
    handleCancel() {
      this.close();
      this.$emit("cancel");
    },
  },
};
</script>
<style lang="scss" scoped>
.edit-dialog {
  background: #f5f5f5;
  .header {
    background: white;
    display: flex;
    border-bottom: 1px solid #efefef;
    height: 50px;
    line-height: 50px;
    text-align: center;
    overflow: hidden;
    div:first-child {
      color: #888;
      width: 60px;
    }

    div:last-child {
      color: #335883;
      width: 60px;
    }

    div:first-child:active,
    div:last-child:active {
      background: #ccc;
    }
  }
}
</style>
